/**
 * 折叠信息弹窗：点击行打开 dialog，max-height 50dvh
 */
(function () {
  function closeModal(modal) {
    if (!modal) return;
    if (typeof modal.close === 'function') {
      modal.close();
    } else {
      modal.removeAttribute('open');
    }
    document.body.classList.remove('oc-mr-modal-open');
  }

  function openModal(modal) {
    if (!modal) return;
    if (typeof modal.showModal === 'function') {
      modal.showModal();
    } else {
      modal.setAttribute('open', '');
    }
    document.body.classList.add('oc-mr-modal-open');
  }

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-oc-collapse-trigger]');
    if (trigger) {
      e.preventDefault();
      const id = trigger.getAttribute('data-modal-target');
      const modal = id ? document.getElementById(id) : null;
      openModal(modal);
      return;
    }

    const closeBtn = e.target.closest('[data-oc-collapse-close]');
    if (closeBtn) {
      e.preventDefault();
      closeModal(closeBtn.closest('[data-oc-collapse-modal]'));
      return;
    }
  });

  document.addEventListener('click', function (e) {
    const modal = e.target.closest('[data-oc-collapse-modal]');
    if (modal && e.target === modal) {
      closeModal(modal);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('[data-oc-collapse-modal][open]').forEach(closeModal);
  });
})();
